import api from "../../../api/axiosInstance";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Alert from "react-bootstrap/Alert";
import moment from "moment";
const ExecuteCanvasCourses = () => {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState([]);
  const [executeCanvasCourses, setExecuteCanvasCourses] = useState([]);
  const [schools, setSchools] = useState([]);
  const [isExecuted, setIsExecuted] = useState(false);
  // On file select (from the pop up)
  const onFileChange = (index, event) => {
    if (selectedFile[index] != undefined) {
      selectedFile[index][1] = event.target.files[0];
      executeCanvasCourses[index][1] = 0;
    } else {
      selectedFile[index] = "";
      selectedFile[index] = [event.target.files[0]];
      executeCanvasCourses[index] = [0];
    }
    setSelectedFile(selectedFile);
    setExecuteCanvasCourses(executeCanvasCourses);
  };

  // On file upload (click the upload button)
  const onFileUpload = () => {
    setIsExecuted(false);
    if (selectedFile.length == 0) {
      toast.error("Choose a file before you execute");
      return;
    }
    setTimeout(() => {
      setIsExecuted(true);
    }, 100);

    selectedFile.forEach((element, index) => {
      setTimeout(() => {
        if (element.length > 1) {
          element.forEach((e, i) => {
            setTimeout(() => {
              uploadFile(e, index, i);
            }, 1000);
          });
        } else {
          uploadFile(element[0], index);
        }
      }, 1000);
    });
  };

  const uploadFile = (file, fIndex, sIndex) => {
    setIsExecuted(false);
    // Create an object of formData
    const formData = new FormData();

    if (sIndex == undefined) {
      executeCanvasCourses[fIndex] = [1];

      // Update the formData object
      formData.append("file", file, file.name);
    } else {
      executeCanvasCourses[fIndex][sIndex] = [1];
      // Update the formData object
      formData.append("file", file, file.name);
    }

    // Request made to the backend api
    // Send formData object
    var config = {
      method: "post",
      url: process.env.REACT_APP_API_URL + "File/FileUpload",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config).then(function (response) {
      if (response.status === 200) {
        setIsExecuted(true);
        ExecuteCanvasCourses(response.data, fIndex, sIndex);
      }
    });
  };

  const ExecuteCanvasCourses = (excelName, fIndex, sIndex) => {
    setIsExecuted(false);
    if (sIndex == undefined) {
      executeCanvasCourses[fIndex] = [2];
    } else {
      executeCanvasCourses[fIndex][sIndex] = [2];
    }
    setIsExecuted(true);
    var config = {
      method: "post",
      url:
        process.env.REACT_APP_API_URL +
        "Courses/ExecuteCourses/" +
        excelName +
        "/School/" +
        (fIndex +
        1),
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config)
      .then(function (response) {
        setIsExecuted(false);
        if (response.data.statusCode === 200) {
          if (sIndex == undefined) {
            executeCanvasCourses[fIndex] = [3];
          } else {
            executeCanvasCourses[fIndex][sIndex] = [3];
          }
          toast.success("Executed");
        } else {
          if (sIndex == undefined) {
            executeCanvasCourses[fIndex] = [4];
          } else {
            executeCanvasCourses[fIndex][sIndex] = [4];
          }
          toast.error(response.data.message);
        }
        setTimeout(() => {
          setIsExecuted(true);
        }, 100);
      })
      .catch(function (error) {
        if (sIndex == undefined) {
          executeCanvasCourses[fIndex] = [4];
        } else {
          executeCanvasCourses[fIndex][sIndex] = [4];
        }

        if (error.response.status === 401) {
          localStorage.clear();
          navigate("/login");
          window.location.reload();
        }
      });
  };

  const getSchools = () => {
    var config = {
      method: "Get",
      url: process.env.REACT_APP_API_URL + "Schools/GetSchools/",
      headers: {
        "Access-Control-Allow-Origin": process.env.REACT_APP_Host,
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    };

    api(config)
      .then(function (response) {
        if (response.data.statusCode === 200) {
          setSchools(response.data.content);
        }
      })
      .catch(function (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          window.location = "/Login";
          window.location.reload();
        }
      });
  };

  useEffect(() => {
    getSchools();
  }, [isExecuted]);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="card mt-5">
              <div className="card-header">
                <h3 className="card-title">
                  Upload Excel - Courses Provisioning.csv
                </h3>
                <div className="align-self-center">
                  <Link
                    to={"/Settings"}
                    className="btn btn-sm btn-secondary mr-5 cts-btn-secondary"
                  >
                    Cancel
                  </Link>
                  <button
                    className="btn btn-sm btn-primary cts-btn-primary"
                    onClick={() => onFileUpload()}
                  >
                    Execute
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row mb-3">
                  <Alert key="warning" variant="warning">
                    Make sure to select a school before clicking on the execute
                    button.
                  </Alert>
                </div>
                {/* <div className="row mb-3">
                  <div className="col-md-3">
                    <h6>1. Select School</h6>
                    <select className="form-control form-control-sm" onChange={(e) => setSelectedOperatorId(e.target.value)}>
                      <option>-- Select School --</option>
                      {operators.map((i) => (
                        <>
                            <option value={i.schoolId}>{i.schoolName}</option>
                        </>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <h6>
                      2. File Selected:{" "}
                      {selectedFile === ""
                        ? "No file selected yet"
                        : selectedFile.name}
                    </h6>
                    <input
                      type="file"
                      className="dropzone custom-file-input"
                      onChange={(e) => onFileChange(e)}
                    />
                  </div>
                </div> */}
                {/* <div className="row">
                  <div className="col-md-12">
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>
                              <h6>Excel Sheet Name</h6>
                            </th>
                            <th>
                              <h6>Status</h6>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Courses Provisioning.csv</td>
                            <td>
                              {executeCanvasCourses === 0 && (
                                <div className="btn btn-primary btn-sm">
                                  Waiting
                                </div>
                              )}
                              {executeCanvasCourses === 1 && (
                                <div className="btn btn-warning btn-sm">
                                  Uploading
                                </div>
                              )}
                              {executeCanvasCourses === 2 && (
                                <div className="btn btn-warning btn-sm">
                                  In Progress
                                </div>
                              )}
                              {executeCanvasCourses === 3 && (
                                <div className="btn btn-success btn-sm">
                                  Done
                                </div>
                              )}
                              {executeCanvasCourses === 4 && (
                                <div className="btn btn-danger btn-sm">
                                  Failed
                                </div>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div> */}
                <div className="row">
                  <div className="col-md-8">
                    <div className="row">
                      <div className="col-md-4">
                        <h5>School Name</h5>
                      </div>
                      <div className="col-md-8">
                        <h5>Excel Sheet/s</h5>
                      </div>
                      <div className="col-md-12">
                        <hr></hr>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="row">
                      <div className="col-md-12">
                        <h5>Status</h5>
                      </div>
                      <div className="col-md-12">
                        <hr></hr>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-8">
                    {schools.map((s, index) => (
                      <>
                        <div className="row">
                          <div className="col-md-4 center-middle-div">
                            <h6>
                              {s.schoolId}. {s.schoolName}
                            </h6>
                          </div>
                          <div className="col-md-4">

                              HS - Course Provisioning
                            <input
                              type="file"
                              className="dropzone custom-file-input"
                              onChange={(e) => onFileChange(index, e)}
                            />
                          </div>

                          <div className="col-md-4">
                            <>
                              MS - Course Provisioning
                              <input
                                type="file"
                                className="dropzone custom-file-input"
                                onChange={(e) => onFileChange(index, e)}
                              />{" "}
                            </>
                          </div>
                          <div className="col-md-12">
                            <hr></hr>
                          </div>
                        </div>
                      </>
                    ))}
                  </div>
                  <div className="col-md-4">
                    <div className="row">
                      {isExecuted && (
                        <>
                          {schools.map((e, index) => (
                            <>
                              {executeCanvasCourses[index] != undefined ? (
                                <>
                                  <div
                                    className="col-md-6 center-middle-div"
                                    style={{ height: "54px" }}
                                  >
                                    {executeCanvasCourses[index][0] == 0 && (
                                      <div className="btn btn-primary btn-sm">
                                        Waiting
                                      </div>
                                    )}
                                    {executeCanvasCourses[index][0] == 1 && (
                                      <div className="btn btn-warning btn-sm">
                                        Uploading
                                      </div>
                                    )}
                                    {executeCanvasCourses[index][0] == 2 && (
                                      <div className="btn btn-warning btn-sm">
                                        In Progress
                                      </div>
                                    )}
                                    {executeCanvasCourses[index][0] == 3 && (
                                      <div className="btn btn-success btn-sm">
                                        Done
                                      </div>
                                    )}
                                    {executeCanvasCourses[index][0] == 4 && (
                                      <div className="btn btn-danger btn-sm">
                                        Failed
                                      </div>
                                    )}
                                  </div>
                                  <div
                                    className="col-md-6 center-middle-div"
                                    style={{ height: "54px" }}
                                  >
                                    {executeCanvasCourses[index][1] == 0 && (
                                      <div className="btn btn-primary btn-sm">
                                        Waiting
                                      </div>
                                    )}
                                    {executeCanvasCourses[index][1] == 1 && (
                                      <div className="btn btn-warning btn-sm">
                                        Uploading
                                      </div>
                                    )}
                                    {executeCanvasCourses[index][1] == 2 && (
                                      <div className="btn btn-warning btn-sm">
                                        In Progress
                                      </div>
                                    )}
                                    {executeCanvasCourses[index][1] == 3 && (
                                      <div className="btn btn-success btn-sm">
                                        Done
                                      </div>
                                    )}
                                    {executeCanvasCourses[index][1] == 4 && (
                                      <div className="btn btn-danger btn-sm">
                                        Failed
                                      </div>
                                    )}
                                  </div>
                                  <div className="col-md-12">
                                    <hr></hr>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div
                                    className="col-md-12 center-middle-div"
                                    style={{ height: "54px" }}
                                  >
                                    <div className="btn btn-danger btn-sm">
                                      No Files Uploaded
                                    </div>
                                  </div>
                                  <div className="col-md-12">
                                    <hr></hr>
                                  </div>
                                </>
                              )}
                            </>
                          ))}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExecuteCanvasCourses;
